import { loadChunk } from './chunks.js';

export default {
    loadedChunks: new Map(),
    isBound: false,
    guardAttr: 'data-chunk-triggered',

    init() {
        if (this.isBound) return;
        this.isBound = true;

        this.delegateEvents();
        this.preloadOnVisible();
    },

    delegateEvents() {
        document.addEventListener('click', this.handleEvent.bind(this, 'click'), true);
        document.addEventListener(
            'pointerdown',
            this.handleEvent.bind(this, 'pointerdown'),
            { passive: true, capture: true }
        );
        document.addEventListener('mouseenter', this.handleEvent.bind(this, 'hover'), true);
    },

    async handleEvent(type, nativeEvent) {
        if (!nativeEvent.target || typeof nativeEvent.target.closest !== 'function') return;
        const trigger = nativeEvent.target.closest('[data-chunk]');
        if (!trigger) return;

        const chunkName = trigger.dataset.chunk;
        if (!chunkName) return;

        const chunkLazy = trigger.dataset.chunkLazy;
        const chunkPreload = trigger.dataset.chunkPreload;
        if (!chunkLazy && !chunkPreload) return;

        const modes = (chunkLazy || 'click')
            .split(/\s+/)
            .filter(Boolean);
        const preloadModes = (chunkPreload || '').split(/\s+/).filter(Boolean);

        const shouldPreload = preloadModes.includes(type);
        const shouldExecute = modes.includes(type) && type === nativeEvent.type;

        if (!shouldPreload && !shouldExecute) return;

        const promise = this.ensureChunkLoaded(chunkName);

        if (shouldExecute) {
            if (trigger.hasAttribute(this.guardAttr)) {
                trigger.removeAttribute(this.guardAttr);
                return;
            }

            nativeEvent.preventDefault();
            nativeEvent.stopPropagation();
            await promise;

            trigger.setAttribute(this.guardAttr, 'true');

            const replayEvent = new nativeEvent.constructor(nativeEvent.type, {
                bubbles: true,
                cancelable: true,
                composed: true,
            });
            trigger.dispatchEvent(replayEvent);
        }
    },

    ensureChunkLoaded(chunkName) {
        if (!this.loadedChunks.has(chunkName)) {
            const promise = loadChunk(chunkName).catch((error) => {
                this.loadedChunks.delete(chunkName);
                console.error(`[lazy-triggers] Échec du chargement du chunk "${chunkName}"`, error);
                throw error;
            });

            this.loadedChunks.set(chunkName, promise);
        }

        return this.loadedChunks.get(chunkName);
    },

    preloadOnVisible() {
        if (!('IntersectionObserver' in window)) {
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    const target = entry.target;
                    observer.unobserve(target);
                    const chunkName = target.dataset.chunk;
                    if (!chunkName) return;
                    if (target.dataset.chunkPreload?.includes('visible')) {
                        this.ensureChunkLoaded(chunkName);
                    }
                });
            },
            { rootMargin: '200px' }
        );

        document.querySelectorAll('[data-chunk][data-chunk-preload]').forEach((el) => {
            observer.observe(el);
        });
    },
};
